/**=========================================================
 * Module: docs.js
 * Docs Controller
 =========================================================*/

App.controller('DocsController',
    ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'ngDialog', 'LocalRestangular', '$sce', '$interval', 'DataService', '$filter', 'toaster',
    function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, ngDialog, LR, $sce, $interval, D, $filter, toaster) {
        "use strict";

        
        $scope.forVendors = $scope.group.indexOf('$')===0
        
        $scope.open = false
        $scope.openDocsBrowser = function(){
            $scope.open = true
            if(!$scope.folder){
                LR.one('files', $scope.group).get({onlyFolder:true}).then(function(resp){
                    $scope.rootFolder = resp.path
                    $scope.folder = $scope.rootFolder
                    $scope.load();
                }).catch(console.error)
            }
            $timeout(function(){ 
                var el = angular.element('#DocsBrowser')
                if(window.innerHeight - el.height() - el[0].getBoundingClientRect().top < 0) {
                    el.height(window.innerHeight - el[0].getBoundingClientRect().top)
                }
            }, 500)
        }
        $scope.closeDocsBrowser = function(){
            $scope.open = false
        }
        if($scope.autoopen){
            $scope.openDocsBrowser()
        }

        $scope.dirs = []
        $scope.files = []
        $scope.loading = false
        $scope.browsing = true
        $scope.filename = ''
        
        $scope.load = function(path){
            $scope.title = $filter('translate')('labels.DOCSFOR', {groupname:$scope.groupname})
            if($scope.forVendors){
                $scope.title = $filter('translate')('labels.DOCSFORVENDORS')
            }
            $scope.filename = ''
            if(path) { 
                if(path=='..') $scope.folder = $scope.folder.substr(0, $scope.folder.lastIndexOf(CONFIG.folderSeparator))
                else {
                    if(path.path){
                        $scope.folder = path.path + CONFIG.folderSeparator + path.name
                    } else {
                        $scope.folder += CONFIG.folderSeparator + path.name
                    }
                }
            }
            $scope.loading = true
            LR.one('fs', CONFIG.folderRoot + $scope.folder).get()
               .then(function (result) {
                   $scope.dirs = result.dirs
                   $scope.files = result.files
                   if($scope.forVendors && $scope.folder==$scope.rootFolder){
                       var genFolder = CONFIG.folderRoot + $scope.rootFolder.substr(0, $scope.rootFolder.lastIndexOf(CONFIG.folderSeparator)) + CONFIG.folderSeparator + '_GENERALE'
                       LR.one('fs', genFolder).get()
                        .then(function(res){
                            if(res.dirs.length){
                                for(var i=0; i<res.dirs.length; i++) { res.dirs[i].path = genFolder, res.dirs[i].isGeneral = true }
                                $scope.dirs = $scope.dirs.concat(res.dirs)
                            }
                            if(res.files.length){
                                for(var i=0; i<res.files.length; i++) { res.files[i].path = genFolder, res.files[i].isGeneral = true }
                                $scope.files = $scope.files.concat(res.files)
                            }
                        }).catch(console.error)
                   }
                   $scope.loading = false
                   $scope.browsing = true
               }).catch(console.error)
        }

        $scope.viewFile = function(f){
            $scope.filename = ''
            $scope.file = null
            $scope.loading = true   
            $scope.filepath = CONFIG.folderRoot + $scope.folder + CONFIG.folderSeparator + f.name
            if(f.path) $scope.filepath = f.path + CONFIG.folderSeparator + f.name
            LR.one('fs', $scope.filepath).get()
                .then(function(result){
                    $scope.filename = f.name
                    if(f.name.endsWith('.docx')){
                        result.fileContent = $sce.trustAsHtml(result.fileContent)
                    }
                    $scope.file = result
                    $scope.loading = false
                    $scope.browsing = false
                }).catch(console.error)
           }
        $scope.openFile = function(f){
            LR.one('explorer', f ? (f.path ? f.path + CONFIG.folderSeparator + f.name : CONFIG.folderRoot + $scope.folder + CONFIG.folderSeparator + file) : $scope.filepath).get().then(function(){}).catch(console.error)
        }
        $scope.closeFile = function(){
            $scope.filename = ''
            $scope.file = null
            $scope.browsing = true
        }
        $scope.openFolder = function(){
            LR.one('explorer', $scope.folder).get().then(function(){}).catch(console.error)
        }

        $scope.pasteFile = function(){
            $scope.form.model[$scope.pastefield] += ($scope.form.model[$scope.pastefield] ? '\n\n' : '') + angular.element('.file-content-container > code').html().replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '<br />').replace(/<br\s*[\/]?>/gi, "\n").replace(/<\/?[^>]+(>|$)/g, "").trim()
        }
    }
]);